import React from "react";
import { Order, OrderValue } from "src/globalTypes";
import { TableColumns } from "src/requests/table/types";
import { ColumnFormatDict } from "src/requests/templates/types";
import { ColumnLabelOverrides } from "../../types";
import { TableDataColumn } from "./TableDataColumn";
import { IMappedHeadColumns, getMappedTableHeadColumns } from "./utils";

const useTableHeadColumns = ({
  columnFormatDict,
  columns,
  columnLabelOverrides,
  onOrder,
  order,
}: {
  columns: TableColumns;
  columnFormatDict: ColumnFormatDict;
  columnLabelOverrides?: ColumnLabelOverrides;
  onOrder: (columnKey: string, order: OrderValue) => void;
  order: Order;
}) => {
  const tableHeadColumns = getMappedTableHeadColumns(
    columns,
    columnFormatDict,
    columnLabelOverrides
  );

  const renderDataColumn = (props: IMappedHeadColumns) => {
    if (props.isHidden) return null;

    return (
      <TableDataColumn
        key={props.columnKey}
        onOrder={onOrder}
        order={order}
        {...props}
      />
    );
  };

  return tableHeadColumns.map(renderDataColumn);
};

export default useTableHeadColumns;
